<template>

  <head>
    <title>Urbanlume</title>
  </head>
  <div class="loader-wrapper" v-if="loading">
    <div class="loader-index"><span></span></div>
    <svg>
      <defs></defs>
      <filter id="goo">
        <feGaussianBlur in="SourceGraphic" stddeviation="11" result="blur"></feGaussianBlur>
        <feColorMatrix in="blur" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo"> </feColorMatrix>
      </filter>
    </svg>
  </div>

  <div v-else>
    <div :style="grayscaleStyle">
      <router-view />
    </div>

    <expired-subscription-modal v-if="showModal && isExpired && modalVisible" @close="handleModalClose" />
  </div>

</template>

<script>
import { jwtDecode } from 'jwt-decode';
import ExpiredSubscriptionModal from './components/global/ExpiredSubscriptionModal.vue';
import { getCookies } from './utils';

export default {
  name: 'App',
  components: {
    ExpiredSubscriptionModal,
  },
  data() {
    return {
      loading: true,
      modalVisible: true,
      autoTimer: null,
    }
  },
  watch: {},

  methods: {
    handleModalClose() {
      this.modalVisible = false
      this.autoTimer = setTimeout(() => {
        this.modalVisible = true
      }, 60 * 1000)
    }
  },
  computed: {
    isExpired() {
      const token = getCookies('token')
      if (!token) return false

      return false

      // const decoded = jwtDecode(token)
      // if (decoded?.Email === "mrantiadmin@vectolabs.com") return true
    },
    grayscaleStyle() {
      return {
        filter: this.modalVisible && this.showModal && this.isExpired ? 'grayscale(100%)' : 'grayscale(0%)',
        transition: 'filter 0.3s ease',
      }
    },
    showModal() {
      const excluded = ["/login", "/v2/login", "/totalsolution", "/v2/totalsolution"]
      return !excluded.includes(this.$route.path.toLowerCase())
    }
  },
  mounted() {
    this.loading = false;
  },
  beforeUnmount() {
    if (this.autoTimer) clearTimeout(this.autoTimer)
  }
}
</script>

<style>
.grayscale-content {
  filter: grayscale(100%);
  transition: filter 0.3s ease;
}
</style>
